import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { BiUserCircle } from 'react-icons/bi';
import { MdOutlineHeadsetMic } from 'react-icons/md';
import { FaFacebookF } from 'react-icons/fa';
import { BsInstagram, BsWhatsapp, BsYoutube } from 'react-icons/bs';
import GenericNavBar from 'newComponents/GenericNavBar';
import {
  ConsultantDataReponse,
  getConsultants,
} from 'services/consultantsServices';
import phoneMask from 'utils/phoneMask';
import { useTour } from 'hooks/useTour';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import {
  Container,
  DescriptionContainer,
  DescriptionTitle,
  DescriptionText,
  ContactContainer,
  ContactInfoWrap,
  ConsultantData,
  ContactInfo,
  ContactName,
  ContactPhone,
  ContactMail,
  ContactDetailWrap,
  ContactDetail,
  SocialMediasTitle,
  SocialMediaItems,
  SocialMediaInfo,
  SocialMediaText,
  ConsultantDataContainer,
  SocialMediaLink,
  Spinner,
  SpinnerWrap,
  TableWrap,
} from './styles';

const BusinessContact: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasContact, setHasContact] = useState<boolean>(false);
  const [consultant, setConsultant] = useState<ConsultantDataReponse>(
    {} as ConsultantDataReponse
  );

  const isMobile = useMediaQuery({ maxWidth: 600 });

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('businessContact');
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  useEffect(() => {
    async function getContacts(): Promise<void> {
      setIsLoading(true);
      const response = await getConsultants();
      setIsLoading(false);

      if (response.length > 0) {
        const consultantResponse: ConsultantDataReponse = response[0];
        const { consultantName } = consultantResponse;
        const stringVerify = 'ATENDIMENTO COMERCIAL';
        if (
          consultantName
            .toLocaleLowerCase()
            .match(stringVerify.toLocaleLowerCase())
        ) {
          setHasContact(false);
        } else {
          setHasContact(true);
          const consultantFormatted: ConsultantDataReponse = {
            name: consultantResponse?.name,
            email: consultantResponse?.email.replace('.invalid', '') || '',
            phone: consultantResponse?.phone
              ? phoneMask(consultantResponse.phone)
              : '',
            consultantName,
          };
          setConsultant(consultantFormatted);
        }
      }
    }
    getContacts();
  }, []);

  return (
    <GenericNavBar
      breadcrump="› Atendimento comercial"
      selected="Atendimento comercial"
      intro={() => true}
    >
      <Container>
        <DescriptionContainer>
          {isLoading && (
            <SpinnerWrap>
              <Spinner color="#0000ff" size={24} />
            </SpinnerWrap>
          )}
          {!isLoading && (
            <>
              <DescriptionTitle>Atendimento Comercial</DescriptionTitle>
              <DescriptionText>
                {hasContact ? (
                  <>
                    Aqui você encontra os dados do(a) consultor(a) responsável
                    pelo seu contrato:
                  </>
                ) : (
                  <>
                    Através deste canal você será direcionado ao atendimento da
                    nossa área de RCR (Relacionamento Comercial Remoto) que
                    poderá apoiá-lo com qualquer questão comercial
                  </>
                )}
              </DescriptionText>
            </>
          )}
        </DescriptionContainer>
        <ConsultantDataContainer>
          {isLoading && (
            <SpinnerWrap>
              <Spinner color="#0000ff" size={24} />
            </SpinnerWrap>
          )}
          {!isLoading && (
            <TableWrap
              showTour={
                showTour && tourType === 'businessContact' && tourStep === 1
              }
            >
              <ConsultantData>
                {!isMobile && (
                  <>
                    <ContactContainer>
                      {hasContact ? (
                        <BiUserCircle size={42} color="#0B29FB" />
                      ) : (
                        <MdOutlineHeadsetMic size={42} color="#0B29FB" />
                      )}
                    </ContactContainer>
                  </>
                )}
                <ContactInfoWrap>
                  <ContactInfo>
                    {hasContact && (
                      <ContactName>{consultant?.name || ''}</ContactName>
                    )}
                    {!hasContact && <ContactName>Fale conosco</ContactName>}
                    {hasContact && consultant?.phone && (
                      <ContactDetailWrap>
                        <ContactPhone>{consultant?.phone}</ContactPhone>
                        <ContactDetail>(Telefone)</ContactDetail>
                      </ContactDetailWrap>
                    )}
                    {!hasContact && (
                      <ContactDetailWrap>
                        <ContactPhone>4003 1616</ContactPhone>
                        <ContactDetail>
                          (Capitais e regiões metropolitanas)
                        </ContactDetail>
                      </ContactDetailWrap>
                    )}
                  </ContactInfo>
                  {isMobile && (
                    <ContactContainer>
                      {hasContact ? (
                        <BiUserCircle size={42} color="#0B29FB" />
                      ) : (
                        <MdOutlineHeadsetMic size={42} color="#0B29FB" />
                      )}
                    </ContactContainer>
                  )}
                </ContactInfoWrap>
                {!hasContact && (
                  <ContactDetailWrap>
                    <ContactPhone>0800 886 1616</ContactPhone>
                    <ContactDetail>(Demais regiões)</ContactDetail>
                  </ContactDetailWrap>
                )}
                {hasContact && consultant?.email && (
                  <ContactDetailWrap>
                    <ContactMail>{consultant?.email}</ContactMail>
                    <ContactDetail>(E-mail)</ContactDetail>
                  </ContactDetailWrap>
                )}
              </ConsultantData>
              {showTour && tourType === 'businessContact' && tourStep === 1 && (
                <TourBalloon
                  title="Atendimento Comercial"
                  content="Aqui você encontra os dados do atendimento comercial responsável pelo seu contrato."
                  position={{
                    left: '232px',
                    right: '0',
                    top: '0',
                    arrowPosition: 'left',
                    maxWidth: 'unset',
                    boxShadow: false,
                    width: '262px',
                    transform: 'translateX(100%)',
                  }}
                />
              )}
            </TableWrap>
          )}
          <SocialMediasTitle>
            <SocialMediaText>Acompanhe nossas redes sociais</SocialMediaText>
          </SocialMediasTitle>
          <SocialMediaItems>
            <SocialMediaLink
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/ultragazoficial"
            >
              <FaFacebookF color="#0B29FB" size={24} />
            </SocialMediaLink>
            <SocialMediaLink
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/ultragazoficial"
            >
              <BsInstagram color="#0B29FB" size={24} />
            </SocialMediaLink>
            <SocialMediaLink
              target="_blank"
              rel="noopener noreferrer"
              href="https://api.whatsapp.com/send?phone=558007010123&data=AWCy0nzRCL3VWxyEoEkMLrTAIB8E1SVaU_fnKplhIRLu6d8NKzNq1mpB5QM8vC7DLKzXS4povPn2qJCCO0rmt2G4M_idEbmRWSrkozOarahtTdKFti50bPeZlnqyo6qFDdIgUt36PdbDCpHW7y_Yx5t6j9CpQ9w1fZQyqMEqsm1bRTyksYB2nF6_i8cLE458cowVRse0try5QcxGm29e-HrLvth6ql5sKO_PkUnKika8e4fffYsHjiP0e4a1NcIE_NGA_rjUGh0iGd1O0wqH6HmmuqDzeya_3IJOXb36&source=FB_Page&app=facebook&entry_point=page_cta"
            >
              <BsWhatsapp color="#0B29FB" size={24} />
            </SocialMediaLink>
            <SocialMediaLink
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCIJ0JnsSqv6LisxSgMsSuqg"
            >
              <BsYoutube color="#0B29FB" size={24} />
            </SocialMediaLink>
          </SocialMediaItems>
          <SocialMediaInfo>
            <SocialMediaText>
              Para atendimento, dê preferência aos nossos canais digitais
            </SocialMediaText>
          </SocialMediaInfo>
        </ConsultantDataContainer>
      </Container>
    </GenericNavBar>
  );
};

export default BusinessContact;
